// extracted by mini-css-extract-plugin
export var carrierTab = "_68-0";
export var carrierTabActive = "_68-1 _68-0";
export var carrierTabInactive = "_68-2 _68-0";
export var carrierTabLabel = "_68-3";
export var carrierTabLabelActive = "_68-4 _68-3";
export var carrierTabLabelInactive = "_68-5 _68-3";
export var carrierTabPercentage = "_68-6";
export var carrierTabPercentageActive = "_68-7 _68-6";
export var carrierTabPercentageInactive = "_68-8 _68-6";
export var carrierTabWinnable = "_68-9";
export var carrierTabWinnableActive = "_68-a _68-9";
export var carrierTabWinnableInactive = "_68-b _68-9";
export var comparisonContainer = "_68-d";
export var missingRateButton = "_68-n";
export var missingRateButtonActive = "_68-o _68-n";
export var missingRateButtonInactive = "_68-p _68-n";
export var missingRateButtonLabel = "_68-q";
export var missingRateButtonLabelActive = "_68-r _68-q";
export var missingRateButtonLabelInactive = "_68-s _68-q";
export var sidebar = "_68-c";
export var strategyButton = "_68-e";
export var strategyButtonActive = "_68-f _68-e";
export var strategyButtonDescription = "_68-k";
export var strategyButtonDescriptionActive = "_68-l _68-k";
export var strategyButtonDescriptionInactive = "_68-m _68-k";
export var strategyButtonInactive = "_68-g _68-e";
export var strategyButtonLabel = "_68-h";
export var strategyButtonLabelActive = "_68-i _68-h";
export var strategyButtonLabelInactive = "_68-j _68-h";
export var unitToggleButton = "_68-t";
export var unitToggleButtonActive = "_68-u _68-t";
export var unitToggleButtonInactive = "_68-v _68-t";
export var unitToggleButtonLabel = "_68-w";
export var unitToggleButtonLabelActive = "_68-x _68-w";
export var unitToggleButtonLabelInactive = "_68-y _68-w";